import { AfterViewInit, Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatInput } from '@angular/material/input';

declare var google: any;

@Component({
  selector: 'app-complete-address',
  templateUrl: './complete-address.component.html',
  styleUrls: ['./complete-address.component.scss']
})
export class CompleteAddressComponent implements OnInit, AfterViewInit {
  @ViewChild(MatInput) inputField: MatInput;
  @ViewChild('inputAutocomplete') inputAutocomplete: ElementRef;

  @Input() title: string;
  @Input() icon: string;
  @Input() draggable: boolean;
  @Input() actionIcon: void;
  @Input() deleteButton: boolean = true;
  @Input() control: FormControl = new FormControl('');

  @Output() remove: EventEmitter<any> = new EventEmitter<any>();
  @Output() location: EventEmitter<any> = new EventEmitter<any>();

  currentlyDraggable = false;
  constructor(private ngZone: NgZone) { }

  private hasCleaned = false;
  private address = null;

  ngOnInit() {
    this.currentlyDraggable = this.draggable;
  }

  ngAfterViewInit() {
    this.initAutocomplete();
  }

  // Reemplazo de MatGoogleMapsAutocompleteModule (dependía de @agm/core como peer
  // dependency), retirado junto con el resto del ecosistema AGM. Misma forma de
  // payload que emitía la directiva vieja: onAutocompleteSelected recibe el
  // PlaceResult crudo, onLocationSelected recibe {latitude, longitude}.
  initAutocomplete() {
    setTimeout(() => {
      const autocomplete = new google.maps.places.Autocomplete(
        this.inputAutocomplete.nativeElement,
        { componentRestrictions: { country: 'co' } }
      );
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          const place = autocomplete.getPlace();
          this.onAutocompleteSelected(place);
          if (place && place.geometry && place.geometry.location) {
            this.onLocationSelected({
              latitude: place.geometry.location.lat(),
              longitude: place.geometry.location.lng()
            });
          }
        });
      });
    }, 1000);
  }

  onBlur() {
    setTimeout(() => {
      this.currentlyDraggable = !this.hasCleaned && this.draggable;
      this.hasCleaned = false;
    }, 100);
  }

  onFocus() {
    this.currentlyDraggable = false;
  }

  onHover() {
    this.currentlyDraggable = this.draggable;
  }

  onRemove() {
    this.remove.emit(true);
  }

  onAutocompleteSelected(e: any) {
    this.address = e;
  }

  onLocationSelected(e: any) {
    this.location.emit({
      address: this.address,
      location: {
        lat: e.latitude,
        lng: e.longitude
      }
    });
    this.inputField.value = this.address.name;
  }
}
